export function HxInput({ className = "", ...rest }) {
  return <input className={`hx-input ${className}`} {...rest} />;
}
export function HxSelect({ className = "", children, ...rest }) {
  return <select className={`hx-select ${className}`} {...rest}>{children}</select>;
}
export function HxLabel({ className = "", children, ...rest }) {
  return <label className={`hx-label ${className}`} {...rest}>{children}</label>;
}
